import styled from 'styled-components';
import type { HBEmptyStateSize } from './HBEmptyState.types';
import spacing from '../../styles/spacing';
import { upToSmall } from '../../styles/breakpoints';

export const EmptyStateContainer = styled.div<{ $size: HBEmptyStateSize }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ $size }) => ($size === 'sm' ? spacing[16] : spacing[24])};
`;

export const GraphicWrapper = styled.div<{ $size: HBEmptyStateSize }>`
    display: grid;
    place-content: center;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${spacing[16]};
`;

export const TextContainer = styled.div<{ $size: HBEmptyStateSize }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${spacing[2]};
    max-width: ${({ $size }) => ($size === 'sm' ? '320px' : '520px')};
`;

export const ActionsContainer = styled.div<{
    $isStacked?: boolean;
}>`
    display: flex;
    align-items: center;
    flex-direction: ${({ $isStacked }) => ($isStacked ? 'column' : 'row')};
    gap: ${({ $isStacked }) => ($isStacked ? spacing[16] : spacing[32])};

    ${upToSmall} {
        flex-direction: column;
        gap: ${spacing[16]};
    }
`;
